// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Tabbar, TabbarItem } from 'vant';
import './assets/icon.css'
import { Icon } from 'vant';
import { Image as VanImage } from 'vant';
import { Button } from 'vant';
import { Cell, CellGroup } from 'vant';
import { NavBar } from 'vant';
import { Search } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Lazyload } from 'vant';
import { Sticky } from 'vant';
import { ActionSheet } from 'vant';
import { IndexBar, IndexAnchor } from 'vant';
import { Switch } from 'vant';
import { Field } from 'vant';
import { Form } from 'vant';
import { Uploader } from 'vant';
import { Tag } from 'vant';
import { GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant';
import { Tab, Tabs } from 'vant';
import { Overlay } from 'vant';
import { Rate } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { DatetimePicker } from 'vant';
import { Popup } from 'vant';
import { Divider } from 'vant';
import { PullRefresh } from 'vant';
import { List } from 'vant';
import { Dialog } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';

Vue.use(Checkbox);
Vue.use(CheckboxGroup);
// 全局注册
Vue.use(Dialog);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Divider);
Vue.use(DatetimePicker)
Vue.use(Popup)

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Rate);
Vue.use(Overlay);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Tag);
Vue.use(Form);
Vue.use(Field);
Vue.use(Uploader);
Vue.use(Switch);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(ActionSheet);
Vue.use(Sticky);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Search);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(VanImage);
Vue.use(Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);

Vue.config.productionTip = false
// router.beforeEach((to, from, next) => {
//   if(to.name === 'details' || to.name === 'pdetails'){
//     const agent = navigator.userAgent
//     const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
//     //因为Android是兼容的，所以只需要判断是不是iOS终端
//     if (isiOS && to.path !== location.pathname) {
//       if(to.fullPath.indexOf('stim') === -1){
//         location.assign("https://www.usababyinfo.com/"+'wysy/'+to.name+"?"+to.fullPath.split("?")[1]+"&stim=1455421")
//       }else{
//         next()
//       }
//       //"https://www.usababyinfo.com/"+'wysy/'+to.name+"?"+to.fullPath.split("?")[1]
//     } else {
//       next()
//     }
//   }
//   next();
// });
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js